// Client-side cache of armed verification links (V2 "Show QR again").
//
// The backend stores only the SHA-256 of the verify token, so a minted
// QR/link can never be re-fetched later — re-POSTing request-verification
// without the token in hand would mint a fresh one and, with an address,
// resend the email (10/day throttle). To keep the design promise "re-display
// is unlimited · without resending", the FE remembers the armed URLs per
// tender in localStorage, TTL-matched to the token's 7-day validity. Same
// storage class as the JWT itself ("tokens"), so this adds no new exposure.
// The cached link also carries the token the modal echoes back on a later
// email send, so that send reuses the SAME verification. If the cache is gone
// (other device, cleared storage) the journey row simply offers "Resend"
// instead of "Show QR again".
const STORAGE_KEY = "tp_agent_verify_links";
const TTL_MS = 7 * 24 * 60 * 60 * 1000; // AGENT_TENDER_VERIFY_TTL_DAYS

const readAll = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return raw && typeof raw === "object" ? raw : {};
  } catch (e) {
    return {};
  }
};

const writeAll = (map) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    /* storage full/unavailable — cache is best-effort only */
  }
};

export const getCachedVerifyLinks = (tenderId) => {
  if (!tenderId) return null;
  const entry = readAll()[String(tenderId)];
  if (!entry || !entry.qrUrl || !entry.linkUrl) return null;
  if (!entry.ts || Date.now() - entry.ts > TTL_MS) {
    clearCachedVerifyLinks(tenderId);
    return null;
  }
  return entry;
};

export const setCachedVerifyLinks = (tenderId, links) => {
  if (!tenderId) return;
  const map = readAll();
  map[String(tenderId)] = { ...links, ts: Date.now() };
  writeAll(map);
};

export const clearCachedVerifyLinks = (tenderId) => {
  const map = readAll();
  if (map[String(tenderId)]) {
    delete map[String(tenderId)];
    writeAll(map);
  }
};
